import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "p-4 bg-white card multisteps-form__panel border-radius-xl shadow-sm",
  "data-animation": "FadeIn"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bolder mb-3" }, "Configurações", -1)
const _hoisted_3 = { class: "multisteps-form__content" }
const _hoisted_4 = { class: "d-flex flex-wrap gap-2 mt-2 mb-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ← Voltar ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Próximo → ")
const _hoisted_7 = { class: "table-responsive p-0" }
const _hoisted_8 = { class: "py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 fw-bold fs-5" }, [
  /*#__PURE__*/_createTextVNode("Acumular Rotas "),
  /*#__PURE__*/_createElementVNode("i", {
    "data-bs-toggle": "tooltip",
    "data-bs-original-title": "Adiciona as rotas a serem criadas às rotas já existentes, sem removê-las.",
    class: "fas fa-question-circle text-success me-2"
  })
], -1)
const _hoisted_10 = { class: "form-check form-switch m-0" }
const _hoisted_11 = { class: "py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 fw-bold fs-5" }, [
  /*#__PURE__*/_createTextVNode(" Incluir Pedidos Alocados "),
  /*#__PURE__*/_createElementVNode("i", {
    "data-bs-toggle": "tooltip",
    "data-bs-original-title": "Ignora se um pedido já está alocado em uma rota, permitindo criar a rota com o pedido novamente.",
    class: "fas fa-question-circle text-success me-2"
  })
], -1)
const _hoisted_13 = { class: "form-check form-switch m-0" }
const _hoisted_14 = { class: "py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 fw-bold fs-5" }, "Respeitar Horário das Janelas", -1)
const _hoisted_16 = { class: "form-check form-switch m-0" }
const _hoisted_17 = { class: "py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 fw-bold fs-5" }, "Menor Distância", -1)
const _hoisted_19 = { class: "form-check form-switch m-0" }
const _hoisted_20 = { class: "py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 fw-bold fs-5" }, "Ordem de Chegada", -1)
const _hoisted_22 = { class: "form-check form-switch m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_argon_button = _resolveComponent("argon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_argon_button, {
          color: "secondary",
          variant: "gradient",
          class: "js-btn-prev",
          title: "Prev",
          onClick: _ctx.$parent.prevStep
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_argon_button, {
          type: "button",
          color: "dark",
          variant: "gradient",
          class: "ms-auto js-btn-next",
          title: "Next",
          onClick: _ctx.$parent.nextStep
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.configuracao.acumular) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, $props.configuracao.acumular]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($props.configuracao.alocados) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, $props.configuracao.alocados]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($props.configuracao.horarios) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, $props.configuracao.horarios]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($props.configuracao.distancia) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, $props.configuracao.distancia]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($props.configuracao.ordenar) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, $props.configuracao.ordenar]
            ])
          ])
        ])
      ])
    ])
  ]))
}